import { Injectable } from '@angular/core'
import { of, tap } from 'rxjs'
import { OrderRoutes } from '../../features/orders/orders-routes.enum'
import { StepStatusType } from '../models/order/order.model'
import { SamlResponse } from '../models/order/saml/saml.model'
import { OrderSetupData } from '../models/order/workflow/order-setup.model'
import { OrderResumeService } from './order-resume.service'
import { Campaign } from '../models/OrderDetails'

@Injectable({
    providedIn: 'root'
})
export class SamlService extends OrderResumeService {
    constructor() {
        super();
    }
  
    processResponse() {
        const samlResponse = this.samlResponse();
        return of(samlResponse).pipe(tap(() => {
            if (samlResponse && samlResponse.ApiResponses) {
                if (samlResponse.ApiResponses.Login) {
                    this.processLogin(samlResponse.ApiResponses.Login);
                }

                if (samlResponse.ApiResponses.Welcome) {
                    this.processWelcome(samlResponse.ApiResponses.Welcome);
                }
                if (samlResponse.ApiResponses.PreOrder) {
                    this.processPreOrder(samlResponse.ApiResponses.PreOrder);
                }

                if (samlResponse.ApiResponses.StartOrder) {
                    this.processStartOrder(samlResponse.ApiResponses.StartOrder);
                }

                this.processOrderSetup(samlResponse);
                
                if (samlResponse.ApiResponses.Customer) {
                    this.processServiceInformationCollection(samlResponse.ApiResponses.Customer);
                }
            }
        }))
    }


    // getSamlNextPage() {
    //     const response = this.samlResponse();
    //     const startOrder = response?.ApiResponses?.StartOrder;
    //     const campaigns = startOrder?.Campaigns ?? [];
    //     if (response?.ApiResponses?.PreOrder?.OrderType === 'consumer' && campaigns.length > 0) {
    //         return campaigns.length > 1 ? 1 : 2;
    //     }
    //     if (campaigns.length > 1 || startOrder?.Accounts?.length > 1 ||
    //         startOrder?.Retailers?.length > 1 || startOrder?.SalesPersons?.length > 1) {
    //         return 1;
    //     }
    //     return response?.MetaData?.NextPage ?? -1;
    // }

    getSamlNextPage() {
        const response = this.samlResponse();
        const startOrder = response?.ApiResponses?.StartOrder;
        const campaigns = startOrder?.Campaigns ?? [];
        if (response?.ApiResponses?.PreOrder?.OrderType === 'consumer' && campaigns.length > 0) {
            return campaigns.length > 1 ? OrderRoutes.ORDER_SETUP : OrderRoutes.SERVICE_INFORMATION;
        }
        if (campaigns.length > 1 || startOrder?.Accounts?.length > 1 ||
            startOrder?.Retailers?.length > 1 || startOrder?.SalesPersons?.length > 1) {
            return OrderRoutes.ORDER_SETUP;
        }
        return this.getNextPage();
    }

    getNextPage() {
        const response = this.samlResponse();
        switch (response?.MetaData?.NextPage) {
            case 1:
                return OrderRoutes.ORDER_SETUP;
            case 2:
                return OrderRoutes.SERVICE_INFORMATION;
            default:
                return OrderRoutes.WELCOME;
        }
    }
    
    private processOrderSetup(samlResponse: SamlResponse) {
        const startOrder = samlResponse.ApiResponses.StartOrder;
        const campaigns = startOrder.Campaigns ?? [];
        const campaign = this.findFirstOrNull(samlResponse, campaigns);
        const salesPerson = startOrder.SalesPersons?.find(person => person.UserId === this.userStateService.getUser()?.UserId)
            ?? startOrder.SalesPersons?.[0];
        const salesPersonId = salesPerson?.UserId.toString() ?? '';
        const account = !campaign ? '' : (campaign
            ? startOrder.Accounts?.find(item => item.CampaignId === campaign.Id)?.DealerCode
            : startOrder.Accounts?.[0]?.DealerCode) ?? '';
        const stores = startOrder.Stores ?? [];
        const store = stores.length > 0 ? stores[0]?.DealerCode : ''
        const orderSetupData: OrderSetupData = {
            orderOptions: {
                orderType: samlResponse.ApiResponses.PreOrder.OrderType,
                interactionType: samlResponse.ApiResponses.PreOrder.InteractionType,
                location: samlResponse.ApiResponses.PreOrder.LocationType,
            },
            salesInformation: {
                account: account,
                salesPerson: salesPersonId,
                selectedDealerCode: account ? account : store,
                campaign: campaign?.Id?.toString() ?? '',
            },
            referenceNumbers: [],
            status: StepStatusType.InProgress
        }
        this.orderSetupStateService.updateData(orderSetupData);
        if (this.getSamlNextPage() === OrderRoutes.SERVICE_INFORMATION) {
            this.orderSetupStateService.markStepComplete();
        }
    }

    findFirstOrNull(samlResponse: SamlResponse, campaigns: Campaign[]): Campaign | null { 
        const orderType = samlResponse.ApiResponses.PreOrder.OrderType;
        if (campaigns.length === 1) {
            return campaigns[0];
        } else if (orderType === 'smb' && campaigns?.length > 1) {
            return campaigns[0];
        }
        return null; 
    }
   
}
